import { Select } from 'antd';
import { useListBatchesQuery } from '../api/stockApi';
import { formatDate } from '@/shared/lib/date';

export interface BatchSelectProps {
  categoryId?: string;
  value?: string;
  onChange: (id: string | undefined) => void;
  disabled?: boolean;
}

/** §11.4: выбор партии для списания — только с остатком, иначе LIFO по умолчанию. */
export function BatchSelect({ categoryId, value, onChange, disabled }: BatchSelectProps) {
  const { data = [], isFetching } = useListBatchesQuery(categoryId ?? '', { skip: !categoryId });

  return (
    <Select<string>
      value={value}
      allowClear
      disabled={disabled || !categoryId}
      loading={isFetching}
      placeholder="LIFO"
      style={{ width: '100%' }}
      onChange={(v) => onChange(v)}
      options={data.map((b) => ({
        value: b.id,
        label: `${formatDate(b.receivedDate)} · ост. ${b.qtyRemaining} · ${b.unitCost}`,
      }))}
    />
  );
}
